import { defineStore } from 'pinia';
import { getToken, setToken, removeToken } from '@/utils/auth';
import { removeRouteListener } from '@/utils/route-listener';
import { appRoutes } from '@/router/routes'
import { UserState } from './types';
import useAppStore from '../app';

const useUserStore = defineStore('user', {
  state: (): UserState => ({
    name: undefined,
    avatar: undefined,
    job: undefined,
    organization: undefined,
    location: undefined,
    email: undefined,
    introduction: undefined,
    personalWebsite: undefined,
    jobName: undefined,
    organizationName: undefined,
    locationName: undefined,
    phone: undefined,
    registrationDate: undefined,
    accountId: undefined,
    certification: undefined,
    role: '',
    loading: false,
    loadingTip: '加载中...',
    token: {},
    profilesUserInfo:{},
    menuRouters: [],
    defaultRoute: ''
  }),

  getters: {
    userInfo(state: UserState): UserState {
      return { ...state };
    },
  },

  actions: {
    switchRoles() {
      return new Promise((resolve) => {
        this.role = this.role === 'user' ? 'admin' : 'user';
        resolve(this.role);
      });
    },
    // Set user's information
    setInfo(partial: Partial<UserState>) {
      this.$patch(partial);
    },

    // Reset user's information
    resetInfo() {
      this.$reset();
    },
    logoutCallBack() {
      const appStore = useAppStore();
      this.resetInfo();
      removeToken();
      removeRouteListener();
      appStore.clearServerMenu();
    },
    setLoading(val:boolean) {
      this.loading = val
    },
    setLoadingTip(tip: string) {
      this.loadingTip = tip
    },
    setToken(){
      // @ts-ignore
      if (getToken() && getToken().indexOf('.') != -1) {
        // @ts-ignore
        const token = getToken().split('.')[1]
        this.token =  JSON.parse(window.atob(token))
      } 
    },
    setProfilesUserInfo(val:object){
      this.profilesUserInfo = val
    },
    setMenuRouters(val:any){
      this.menuRouters = appRoutes.filter(item=> item.name == val)
    },
    setDefaultRoute(path: string) {
      this.defaultRoute = path;
    },
  },
});

export default useUserStore;
